import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings.js'; // Added Modal, Descriptions
import Footerdiv from "../layout/footer.js";
import Headerdiv from "../layout/header.js";
import { Layout, Typography, Form, Input, Select, Button, Table, Card, Row, Col, Space, Tag, theme, Popconfirm, Breadcrumb, Tooltip, Modal, Descriptions } from 'antd';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { exportMlmUserReportToExcel } from './mlm-user-report.js';

const { Option } = Select;
const { Content } = Layout;

const UserList = () => {
  const navigate = useNavigate();

  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");

  const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);

  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isActivityModalVisible, setIsActivityModalVisible] = useState(false);
  const [selectedUserForActivity, setSelectedUserForActivity] = useState(null);
  const [isReportDownloading, setIsReportDownloading] = useState(false);

  const [searchParams, setSearchParams] = useState({
    username: '',
    nic: '',
    mobileNo: '',
    status: '',
  });

  const [form] = Form.useForm();

  const columns = [

    {
      title: 'Consult ID',
      dataIndex: 'userId',
      key: 'userId',
    },
    {
      title: 'First Name',
      dataIndex: 'firstname',
      key: 'firstname',
      sorter: (a, b) => a.firstname?.localeCompare(b.firstname || ''),
    },
    {
      title: 'Last Name',
      dataIndex: 'lastname',
      key: 'lastname',
      sorter: (a, b) => a.lastname?.localeCompare(b.lastname || ''),
    },
    {
      title: 'NIC',
      dataIndex: 'nic',
      key: 'nic',
    },
    {
      title: 'Mobile Number',
      dataIndex: 'mobileNo',
      key: 'mobileNo',
    },
    {
      title: 'Sponsor ID  ',
      dataIndex: 'assignConsultant',
      key: 'assignConsultant',
      render: (assignConsultant) => {

        return (
          <Space size="small">
            {assignConsultant}
          </Space>
        );
      },
    },
    {
      title: 'Verified',
      dataIndex: 'verified',
      key: 'verified',
      render: (active) =>
        active === true ? (
          <Tooltip title="Verified">
            <CheckCircleFilled style={{ color: "green", fontSize: "18px" }} />
          </Tooltip>
        ) : (
          <Tooltip title="Not Verified">
            <CloseCircleFilled style={{ color: "red", fontSize: "18px" }} />
          </Tooltip>
        ),
    },
    {
      title: 'Status',
      dataIndex: 'active',
      key: 'active',
      render: (active) =>
        active === true ? (
          <Tooltip title="Active">
            <CheckCircleFilled style={{ color: "green", fontSize: "18px" }} />
          </Tooltip>
        ) : (
          <Tooltip title="Deactive">
            <CloseCircleFilled style={{ color: "red", fontSize: "18px" }} />
          </Tooltip>
        ),
    },
    {
      title: 'Is Deleted'
      , dataIndex: 'delete',
      key: 'delete',
      render: (active) =>
        active === true ? (
          <Tooltip title="Active">
            <CheckCircleFilled style={{ color: "green", fontSize: "18px" }} />
          </Tooltip>
        ) : (
          <Tooltip title="Deactive">
            <CloseCircleFilled style={{ color: "red", fontSize: "18px" }} />
          </Tooltip>
        ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => {
        return (
          <Space size="small">

            <Button
              type="primary"
              size="small"
              onClick={() => getUserDetail(record)}
            >
              View
            </Button>
            <Button
              type="default"
              variant='outlined'
              color='yellow'
              size="small"
              onClick={() => navigate(`/mlm/userlist/edit/${record.userId}`)} // Navigate to edit page
            >
              Edit
            </Button>
            <Button
              size="small"
              style={{ backgroundColor: 'purple', borderColor: 'purple', color: 'white' }}
              onClick={() => {
                setSelectedUserForActivity(record);
                setIsActivityModalVisible(true);
              }}
            >
              Activity
            </Button>
            {record.active === true && (
              < Popconfirm
                title="Are you sure you want to delete this user?"
                description="This action cannot be undone."
                onConfirm={() => deleteUser(record.userId)}
                okButtonProps={{ danger: true }}
                okText="Yes, Delete"
                cancelText="No"
              >
                <Button size="small" variant='solid' danger>Delete</Button>
              </Popconfirm>
            )
            }
          </Space >
        );
      },
    },
  ];

  const handlePageChange = (page, pageSize) => {
    form.validateFields().then(values => {
      handleFilter(values, page);
    });
  };

  // Pagination configuration
  const paginationConfig = {
    current: currentPage,
    pageSize: rowsPerPage,
    total: totalRecords,
    onChange: handlePageChange,
    showSizeChanger: false,
    showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`
  };


  const handleClear = () => {
    form.resetFields();
    const defaultParams = {
      username: '',
      nic: '',
      mobileNo: '',
      status: '',
    };
    setSearchParams(defaultParams);
    handleFilter(defaultParams, 1);
  };


  const getUserDetail = (user) => {
    navigate(`/mlm/userview/${user.userId}`);
  };


  useEffect(() => {
    handleClear();
  }, []);

  const handleFilter = async (values, pageNum = 1) => {

    setLoading(true);
    try {
      const requestParams = {
        username: values.username || '',
        nic: values.nic || '',
        mobileNo: values.mobileNo || '',
        status: values.status || '',
        pageLength: rowsPerPage,
        pageNumber: pageNum,
      };

      const response = await axios.post(
        `${ApiURL}/erp/mlmuser/list`,
        requestParams,
        {
          headers: { SystemAccessToken: TOKEN }
        }
      );

      let records = [];
      let total = 0;

      if (response.data) {

        if (response.data.dataList && Array.isArray(response.data.dataList)) {
          records = response.data.dataList;
          total = response.data.rowcount || records.length;

        }
        // Check for direct array response
        else if (Array.isArray(response.data)) {
          records = response.data;
          total = records.length;
        }
        // Check for records array in response
        else if (response.data.records && Array.isArray(response.data.records)) {
          records = response.data.records;
          total = response.data.totalRecords || records.length;
        }
        // Check for data array in response (common API pattern)
        else if (response.data.data && Array.isArray(response.data.data)) {
          records = response.data.data;
          total = response.data.total || records.length;
        }
        // Check if it's a single object that needs to be wrapped in an array
        else if (response.data.poId && typeof response.data === 'object') {
          records = [response.data];
          total = 1;
        }
        // Handle unexpected formats
        else {
          AlertError("Data Error");
          // Don't clear existing data on error - this might be causing the disappearing data
          if (filteredData.length > 0) {
            return; // Early return to keep existing data
          }
          records = [];
          total = 0;
        }
      }
      if (response.data.length == 0) {
        records = [response.data];

      }

      if (records.length === 0 && filteredData.length > 0) {

        return; // Don't update state if we got no records but have existing data
      }

      // Make sure records have all required fields with defaults
      const processedRecords = records.map(record => ({
        userId: record.userId || '',
        userName: record.userName || '', // <-- fix this!
        firstname: record.firstname || '',
        lastname: record.lastname || '',
        nic: record.nic || '',
        mobileNo: record.mobileNo || '',
        assignConsultant: record.assignConsultant || '',
        active: record.active || '', // <-- for status badge
      }));

      // Only update if we have records to show
      if (processedRecords.length > 0) {
        setFilteredData(processedRecords);
        setTotalRecords(total);
        setCurrentPage(pageNum);
        setSearchParams(values);
      }
    } catch (error) {

      AlertError('Failed to filter mlm users: ' + (error.message || 'Unknown error'));
      // Don't clear existing data on error
      if (filteredData.length === 0) {
        setFilteredData([]);
        setTotalRecords(0);
        setCurrentPage(1);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseActivityModal = () => {
    setIsActivityModalVisible(false);
    setSelectedUserForActivity(null);
  };

  const downloadReport = async () => {
    if (!selectedUserForActivity) {
      AlertError("No user selected.");
      return;
    }

    try {
      setIsReportDownloading(true);
      const response = await axios.post(`${ApiURL}/erp/mlmuser/getuseractivityreport/${selectedUserForActivity.userId}`, {}, { headers: { SystemAccessToken: TOKEN } });
      const consultantList = response.data; // Assuming response.data is the array of consultant objects

      const success = exportMlmUserReportToExcel(consultantList, selectedUserForActivity);
      if (success) {
        AlertSuccess('Report generated successfully. Please check your downloads folder.');
        handleCloseActivityModal();
      } else {
        AlertError('Failed to generate report. Please try again.');
      }
    } catch (error) {
      console.error('Error downloading report:', error);
      AlertError('Failed to download report.');
    } finally {
      setIsReportDownloading(false);
    }
  };

  const deleteUser = async (userId) => {
    try {
      const headers = {
        SystemAccessToken: TOKEN,
      }
      const res = await axios.get(`${ApiURL}/erp/mlmuser/activeuserdelete/${userId}`,{headers})
      if (res.data === true) {
        handleClear()
        AlertSuccess('User deleted successfully');
      } else {
        AlertError('Failed to delete user');
      }
    } catch (error) {
      AlertError('Failed to delete user');
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
      <Headerdiv />
      <Content style={{ padding: '10px' }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>MLM User List</Breadcrumb.Item>
        </Breadcrumb>

        <div style={{ padding: 20, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
          <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                {/* Search Form */}
                <Card title="Search users" style={{ marginBottom: 16 }}>
                  <Form
                    form={form}
                    name="search_form"
                    layout="vertical"
                    onFinish={handleFilter}
                    initialValues={searchParams}
                  >
                    <Row gutter={[16, 8]}>
                      <Col xs={24} sm={12} md={4}>
                        <Form.Item name="username" label="Search user Name/ID">
                          <Input placeholder="Search..." allowClear />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5}>
                        <Form.Item name="nic" label="Search NIC">
                          <Input placeholder="Search..." allowClear />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5}>
                        <Form.Item name="mobileNo" label="Search mobile number">
                          <Input placeholder="Search..." allowClear />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5}>
                        <Form.Item name="status" label="Search status">
                          <Select placeholder="Select status" allowClear>
                            <Select.Option value="Active">Active</Select.Option>
                            <Select.Option value="Inactive">Inactive</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={5} style={{ display: 'flex', alignItems: 'center' }}>
                        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                          <Button type="primary" htmlType="submit">
                            Filter
                          </Button>
                          <Button onClick={handleClear}>
                            Clear
                          </Button>
                        </Space>
                      </Col>
                    </Row>
                  </Form>
                </Card>

                {/* Data Table */}
                <Card title="MLM user list">
                  <div style={{ overflowX: 'auto' }}>
                    <Table
                      columns={columns}
                      dataSource={filteredData}
                      pagination={paginationConfig}
                      rowKey="userId"
                      size="middle"
                      loading={loading}
                      scroll={{ x: 'max-content' }}
                      locale={{
                        emptyText: loading ? 'Loading...' : (
                          <div>
                            <p>No data found</p>

                          </div>
                        )
                      }}
                    />
                  </div>
                </Card>
              </Col>
            </Row>
          </Space>
        </div>

      </Content>

      {/* Activity Modal */}
      <Modal
        title="Generate Activity Report"
        open={isActivityModalVisible}
        onCancel={handleCloseActivityModal}
        footer={[
          <Button key="back" onClick={handleCloseActivityModal}>
            Close
          </Button>,
          <Button key="download" type="primary" onClick={downloadReport} loading={isReportDownloading}>
            Download Report
          </Button>,
        ]}
      >
        {selectedUserForActivity && (
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Consult ID">{selectedUserForActivity.userId}</Descriptions.Item>
            <Descriptions.Item label="First Name">{selectedUserForActivity.firstname}</Descriptions.Item>
            <Descriptions.Item label="Last Name">{selectedUserForActivity.lastname}</Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
      <Footerdiv />
    </Layout>
  );
};

export default UserList;
